
import { Vue, Component, Prop } from "vue-property-decorator";
import { ChartAggregate } from "zaehlerfreunde-central/ui_service_pb";

@Component
export default class ChartAggregates extends Vue {
  @Prop({ default: [] })
  aggregates: ChartAggregate[];
}
